module.exports = __webpack_public_path__ + "img/2H.8dc4812f.png";